import type {
  Dispensaries,
  DutchiePosLoyaltyConfig,
  EnterpriseLoyaltySettingsQuery,
  RewardsListV2,
} from 'src/gql/graphql';

export type Enterprise = EnterpriseLoyaltySettingsQuery['enterpriseLoyaltySettings'];

export const FLOW_STEPS = {
  LANDING: 'landing',
  LOGIN_METHOD: 'login-method',
  EMAIL_SIGNUP: 'email-signup',
  LOYALTY_REWARDS: 'loyalty-rewards',
} as const;

export type FlowStep = typeof FLOW_STEPS[keyof typeof FLOW_STEPS];

export type LandingPageProps = {
  enterprise: Enterprise;
  onStartEarningRewards: (selectedState: string) => void;
  /** Fired as soon as a state is known for theming (POS-17999), before the user clicks/confirms. */
  onLikelyStateDetected?: (stateCode: string) => void;
  /** Best dispensary available to theme from (POS-17999). Null/undefined means no real customization known yet. */
  themeDispensary?: Dispensaries | null;
  /** growth.ecomm.enterprise-signup-custom-branding.rollout for this enterprise. */
  customBrandingEnabled?: boolean;
};

export type LoginMethodSelectionProps = {
  onContinueWithEmail: () => void;
};

export type LoyaltyRewardsProps = {
  enterprise: Enterprise;
  rewards?: RewardsListV2 | null;
  loyaltyConfigData?: DutchiePosLoyaltyConfig | null;
  rewardsDataLoading?: boolean;
  loyaltyConfigLoading?: boolean;
  isEmbedMode?: boolean;
};
